import { useState, useContext, useEffect } from 'react'
import getFp from 'lodash/fp/get'
import { Modal, RoundButton } from '../styled'
import { useDispatch, useSelector } from 'react-redux'
import YoutubeAPIContext from './YoutubeQuestioner/context'
import { closeModal } from '../store/modal'
import { delay } from 'lodash'
import { usePostAnswerMutation } from '../store/api'

export default function QuestionModal() {
  const [answerText, setAnswerText] = useState('')
  const [status, setStatus] = useState('close')
  const { player } = useContext(YoutubeAPIContext)
  const dispatch = useDispatch()
  const [postAnswer] = usePostAnswerMutation()
  const onChange = ({ target }) => setAnswerText(target.value)

  const question = useSelector(getFp('modal.value'))

  const onQuestionAnswer = () => {
    player.api.playVideo()
    setAnswerText('')
    dispatch(closeModal())

    const answer = { questionId: question.questionId, text: answerText }
    postAnswer(answer)
  }

  useEffect(() => {
    if (question && status === 'close') {
      setStatus('toggle')

      delay(() => setStatus('open'), 50)
    }
    if (!question && status === 'open') {
      setStatus('close')
    }
  }, [question, status])

  return (
    <Modal status={status}>
      <Modal.Wrapper onClick={() => { 
        dispatch(closeModal())
       }}>
        <Modal.Body onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          return false
        }}>
          <Modal.Text>{question?.text}</Modal.Text>
          <Modal.TextArea
            onChange={onChange}
            value={answerText}
            placeholder="Type your answer"
            rows={3}
          ></Modal.TextArea>
          <RoundButton disabled={!answerText} onClick={onQuestionAnswer}>
            Answer!
          </RoundButton>
        </Modal.Body>
      </Modal.Wrapper>
    </Modal>
  )
}
